import {createContext} from "react";

const isDarkMode = createContext<boolean>(false);
export default isDarkMode;